import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { isScreenBelow1004 } from 'store/common/settings/breakpoint/selectors';
import { getFeedbackSubmitStatus, getFeedbackAvailability } from 'store/ProductDetails/selectors';
import {
  FEEDBACK_STATUS_ERROR,
  FEEDBACK_STATUS_VALIDATION,
  FEEDBACK_STATUS_SUCCESS,
  FEEDBACK_STATUS_INITIAL,
} from 'store/ProductDetails/feedbackLocal/constants';
import { SectionGroup /* , Section, */ } from 'bricks';

import TabRouterLayout from '../_TabLayout';
import FeedbackList from './components/FeedbackList';
import FeedbackForm from './components/FeedbackForm';
import FeedbackStatus from './components/FeedbackStatus';
import FeedbackSortBy from './components/FeedbackSortBy';
import FeedbackSum from './components/FeedbackSum';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const RightCol = () => {
  return (
    <div className={cx('right')}>
      <FeedbackSortBy />
      <FeedbackSum />
    </div>
  );
};

class FeedbackTab extends React.Component {
  renderFeedbackForm = () => {
    const { submitStatus } = this.props;
    switch (submitStatus) {
      case FEEDBACK_STATUS_SUCCESS:
        return <FeedbackStatus />;
      case FEEDBACK_STATUS_ERROR:
        return <FeedbackStatus isError />;
      default:
        return <FeedbackForm />;
    }
  };

  render() {
    const { hasFeedback, isMobile } = this.props;
    return (
      <TabRouterLayout RightCol={hasFeedback && RightCol}>
        <SectionGroup>
          {isMobile && <FeedbackSum />}
          {hasFeedback ?
            <div className={cx('reviews', isMobile && 'mobile')}>
              <div className={cx(isMobile ? 'headingWrapMobile' : 'headingWrap')}>
                <div className={cx('header', isMobile && 'mobile')}>Отзывы покупателей</div>
                {/* <FeedbackSortBy /> */}
              </div>
              {isMobile && <FeedbackSortBy />}
              <FeedbackList />
            </div>
          : null}
          {this.renderFeedbackForm()}
        </SectionGroup>
      </TabRouterLayout>
    );
  }
}

FeedbackTab.propTypes = {
  submitStatus: PropTypes.oneOf([
    FEEDBACK_STATUS_ERROR,
    FEEDBACK_STATUS_SUCCESS,
    FEEDBACK_STATUS_INITIAL,
    FEEDBACK_STATUS_VALIDATION,
  ]),
  hasFeedback: PropTypes.bool,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  submitStatus: getFeedbackSubmitStatus(state),
  hasFeedback: getFeedbackAvailability(state),
  isMobile: isScreenBelow1004(state),
});

export default connect(mapStateToProps)(FeedbackTab);
